import SurveyQuestionsList from "./SurveyQuestionsList";

export default SurveyQuestionsList;